document.addEventListener('DOMContentLoaded', () => {
  const modalOverlay = document.querySelector('#modal-overlay');
  const popupModal = document.querySelector('#popup-modal');
  const productDetails = document.querySelector('#product-details');
  const closeModalButton = document.querySelector('#close-modal');

  let currentProductHandle = null;

  const clearModalContent = () => {
    console.log('Clearing modal content...');
    productDetails.innerHTML = '';
    currentProductHandle = null;
  };

  const openModal = () => {
    console.log('Opening modal...');
    clearModalContent();
    modalOverlay.style.display = 'block';
    popupModal.style.display = 'block';
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    console.log('Closing modal...');
    modalOverlay.style.display = 'none';
    popupModal.style.display = 'none';
    document.body.style.overflow = '';
    setTimeout(clearModalContent, 300);
  };

  const loadProductDetails = (handle) => {
    clearModalContent();
    productDetails.innerHTML = '<p>Loading...</p>';
    currentProductHandle = handle;

    fetch(`/products/${handle}?view=quickview_data`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch product details');
        }
        return response.text();
      })
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const productSection = doc.querySelector('.product-section');

        clearModalContent();

        if (productSection) {
          productDetails.appendChild(productSection);

          setTimeout(() => {
            if (jQuery("#product-details #customise_button").is(":hidden")) {
              jQuery("#product-details .add_to_cart").css("display", "block");
              document.getElementsByClassName("loader")[0].style.display = "none";
            }
            document.addEventListener('click', (e) => {
              // Handle popup close button
              if(e.target.closest('a.popup-close-custom')){
                if(document.body.classList.contains('popup-open-custom')){
                  document.body.classList.remove('popup-open-custom');
                  // Set the z-index of .theme__header to 5000
                  document.querySelector('.theme__header').style.zIndex = '5000';
                }
              }
              
              // Handle size text wrap click
              if(e.target.closest('.size-text-wrap-custom')){
                document.body.classList.add('popup-open-custom');
                // Set the z-index of .theme__header to 0
                document.querySelector('.theme__header').style.zIndex = '0';
              }
            });
            document.querySelectorAll('.popup-modal .selector-wrapper input[type="radio"]').forEach(button => {
              button.addEventListener("click", function () {
                var selectBox = document.getElementById('product-variant-select');
                var options = selectBox.querySelectorAll('option');
                var variantOptions = '';
                var option1 = document.querySelector('.selector-wrapper[data-option-position="1"] input[type="radio"]:checked');
                var option2 = document.querySelector('.selector-wrapper[data-option-position="2"] input[type="radio"]:checked');
                var option3 = document.querySelector('.selector-wrapper[data-option-position="3"] input[type="radio"]:checked');
            
                if (option1) {
                  variantOptions = option1.value;
                  document.querySelector('.selector-wrapper[data-option-position="1"]').querySelector('[data-option-value]').innerText = option1.value;
                }
                if (option2) {
                  variantOptions += '/' + option2.value;
                  document.querySelector('.selector-wrapper[data-option-position="2"]').querySelector('[data-option-value]').innerText = option2.value;
                }
                if (option3) {
                  variantOptions += '/' + option3.value;
                  document.querySelector('.selector-wrapper[data-option-position="3"]').querySelector('[data-option-value]').innerText = option3.value;
                }
                variantOptions = variantOptions.toLowerCase();
            
                options.forEach(function(option) {
                  if (option.getAttribute('data-val') == variantOptions) {
                    selectBox.value = option.value;
                    var inputValue = document.querySelector('.shopify-product-form input[name="id"]');
                    if (inputValue) {
                      inputValue.value = option.value;
                    }
                    
                    var variantImage = option.getAttribute('data-variant-image');
                    var mediaThumb = document.querySelector('.media__thumb[data-media-select="'+ variantImage +'"]');
                    if (mediaThumb) {
                      mediaThumb.dispatchEvent(new Event('click'));
                    }
                  }
                });
              });
            });
            
            document.querySelectorAll('.popup-modal .shopify-product-form').forEach(function (form) {
              form.addEventListener('submit', function (event) {
                event.preventDefault();
                const quickViewFormData = new FormData(form);
                fetch('/cart/add.js', {
                  method: 'POST',
                  body: quickViewFormData,
                })
                  .then(response => response.json())
                  .then(data => {
                    closeModal();
                    const cartDrawer = document.querySelector('.cart__drawer');
                    if (cartDrawer) {
                      cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', {
                        detail: {
                          cart: data,
                          customParam: "customAddItemEvent",
                        },
                        bubbles: true,}));
                      // Dispatch the 'theme:cart:init' event
                      document.dispatchEvent(new CustomEvent('theme:cart:init', { bubbles: true }));
                    } else {
                      window.location.href = "/cart";
                    }
                  })
                  .catch(error => {
                    console.error('Error adding product to cart:', error);
                  });
              });
            });
          }, 3000);

          const scripts = productSection.querySelectorAll('script');
          scripts.forEach((script) => {
            const scriptTag = document.createElement('script');
            if (script.src) {
              scriptTag.src = script.src;
            } else {
              scriptTag.textContent = script.textContent;
            }
            // productDetails.appendChild(scriptTag);
          });
        } else {
          productDetails.innerHTML = '<p>Failed to load product details.</p>';
        }
      })
      .catch((error) => {
        console.error('Error fetching product details:', error);
        productDetails.innerHTML = '<p>Error loading product details.</p>';
      });
  };

  document.body.addEventListener('click', (event) => {
    const card = event.target.closest('.custom_atc_card');
    if (card) {
      const handle = card.getAttribute('data-handle');
      if (!handle) {
        console.error('No product handle found for this card.');
        return;
      }
      console.log('Product handle clicked:', handle);
      openModal();
      loadProductDetails(handle);
    }
  });

  closeModalButton.addEventListener('click', closeModal);
  modalOverlay.addEventListener('click', closeModal);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeModal();
    }
  });
});